import {
  IsArray,
  IsBoolean,
  IsIn,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import { VacationUnitItem } from '@app/gen/vacations';

export class EditScheduleDto {
  @IsIn(['units', 'employees', 'custom_type'])
  @IsString()
  @IsNotEmpty()
  type: 'units' | 'employees' | 'custom_type';

  @IsString()
  @IsNotEmpty()
  companyName: string;

  @IsNumber()
  @IsNotEmpty()
  year: number;

  @IsUUID()
  @IsNotEmpty()
  scheduleId: string;

  @IsBoolean()
  @IsOptional()
  includeAllNewEmployees?: boolean;

  @ValidateNested({ each: true })
  @Type(() => VacationUnitItem)
  @IsArray()
  @IsOptional()
  includeUnits?: VacationUnitItem[];

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  includePositions?: string[];

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  includeEmployees?: string[];

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  excludeEmployees?: string[];
}
